import React, { Component } from 'react';
import { loginWithGoogle } from '../helpers/auth';
import { firebaseAuth } from '../config/constants';
const firebaseAuthKey = 'firebaseAuthInProgress';
const appTokenKey = 'appToken';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { splashScreen: false };
    this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
  }
  handleGoogleLogin() {
     loginWithGoogle()
     console.log('login??')
     .catch(err => {
      localStorage.removeItem(firebaseAuthKey)
     });
// this will set the splashscreen until its overridden by the real firebaseAuthKey
     localStorage.setItem(firebaseAuthKey, '1');
  }
  componentWillMount() {
    console.log('found loading')
  // checks if we are logged in, if we are go to the home route
  if (localStorage.getItem(appTokenKey)) {
    this.props.history.push('/app/home');
    return;
  }

  firebaseAuth().onAuthStateChanged(user => {
    console.log('anything', user)
    if (user) {
      console.log('found user', user)
      localStorage.removeItem(firebaseAuthKey);
      localStorage.setItem(appTokenKey, user.uid);
      this.props.history.push('/app/home')
    }
  })
}

render() {
  if (localStorage.getItem(firebaseAuthKey) === '1') 
    return <Splashscreen />;
    return <LoginPage handleGoogleLogin={this.handleGoogleLogin} />;
  }
}
// this is the URL we copied from firebase storage
const loginButtonUrl = 'https://firebasestorage.googleapis.com/v0/b/wheresmyart-ec3dc.appspot.com/o/google-icon-white.png?alt=media&token=09eab966-01bc-476e-9a04-4a8cf3bdc04b';
const styles = {
 backgroundImage: `url(${loginButtonUrl})`
}

const LoginPage = ({ handleGoogleLogin }) => (
  <div className="login-container">
    <div onClick={handleGoogleLogin} className="login-button">
    <div style={styles} className="google-logo">
      <span className="button-text">Sign In With Google</span>
    </div>
    </div>
  </div>
)
const Splashscreen = () => (<p>Please Wait Loading...</p>);